import { Box, Button, Heading, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

export default function NoTeamsBanner() {
	const { t } = useTranslation();

	return (
		<Box display="flex" flexDir="column" p="4" h="100%">
			<Heading textAlign="center" size="lg">
				{t('You have no teams yet.')}
			</Heading>

			<Text
				mt={4}
				textAlign={{
					base: 'left',
					md: 'center',
				}}
			>
				{t('Share booking pages resources and agendas with your coworkers.')}
			</Text>

			<Button mt="auto" colorScheme="primary" w="100%">
				{t('Create a new team')}
			</Button>
		</Box>
	);
}
